import React from "react";

import "./PoiItemStyle.css";

const PoiItem = ({ title, href }) => {
  return (
    <a className="poi-link" target="_blank" rel="noreferrer" href={href}>
      {title}
    </a>
  );
};

export default PoiItem;
